// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__UkRqc","image":"Image_image__3QFzw","loaded":"Image_loaded__Dd_EQ"};